import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Bell } from "lucide-react";
import { Helmet } from "react-helmet";
import ContainerPage from "../../components/Containers/ContainerPage";
import TitlePage from "../../components/Texts/TitlePage";
import GlobalNotificationAlertItem from "../../components/Alerts/GlobalNotificationAlertItem";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import {
  dismissGlobalNotification,
  markGlobalNotificationsAsRead,
} from "../../actions/globalNotifications";
import { getNameBusinessTheme } from "../../actions/getters";
import {
  GLOBAL_ALERTS_EMPTY,
  GLOBAL_ALERTS_EMPTY_DESCRIPTION,
  GLOBAL_ALERTS_PANEL_TITLE,
} from "../../i18n/keysTranslations";

const Notifications = () => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { theme } = useSelectorApp((state) => state.ui);
  const globalAlerts = useSelectorApp(
    (state) => state.alerts?.globalAlerts || []
  );
  const businessName = theme.nameBusiness || dispatch(getNameBusinessTheme());
  const hasAlerts = globalAlerts.length > 0;

  useEffect(() => {
    const unreadIds = globalAlerts
      .filter((alert) => !alert.isRead)
      .map((alert) => alert.id);

    if (unreadIds.length > 0) {
      dispatch(markGlobalNotificationsAsRead(unreadIds));
    }
  }, [globalAlerts, dispatch]);

  const onCloseAlert = (alertId) => {
    dispatch(dismissGlobalNotification(alertId));
  };

  return (
    <>
      <Helmet>
        <title>{`${businessName} - ${t(GLOBAL_ALERTS_PANEL_TITLE)}`}</title>
      </Helmet>
      <ContainerPage hasMarginBottom={false} sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            width: "100%",
            px: 3,
            mt: 4,
          }}
        >
          <TitlePage>{t(GLOBAL_ALERTS_PANEL_TITLE)}</TitlePage>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              width: "100%",
              mt: 1,
              pb: hasAlerts ? 15 : 0,
              flex: 1,
              minHeight: 0,
            }}
          >
            {hasAlerts ? (
              globalAlerts.map((alert) => (
                <GlobalNotificationAlertItem
                  key={alert.id}
                  alert={alert}
                  onClose={onCloseAlert}
                />
              ))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                  width: "100%",
                  minHeight: "calc(100vh - 380px)",
                  textAlign: "center",
                }}
              >
                <Bell size={48} strokeWidth={1.5} />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    mt: 1.5,
                    color: "text.primary",
                  }}
                >
                  {t(GLOBAL_ALERTS_EMPTY)}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.75rem",
                    mt: 0.5,
                    color: "text.secondary",
                  }}
                >
                  {t(GLOBAL_ALERTS_EMPTY_DESCRIPTION)}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </ContainerPage>
    </>
  );
};

export default Notifications;
